module.exports = __webpack_public_path__ + "img/mpg.a3181c4c.png";